// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SizeMonitor_wrapper__pWZ2x","active":"SizeMonitor_active__j7oM6","inner":"SizeMonitor_inner__ea5ry"};